












import { Vue, Component } from 'vue-property-decorator';
import { enums } from '@/common/enums';
@Component({
    components: {  },
})
export default class Project extends Vue {
    public $refs: {
        date: HTMLFormElement;
    };

    created() {}
}
